import { UseGQLQueryConfig } from 'hooks/useGQLQuery/useGQLQuery.types';
import { QUERY_fetchOrderCanAssign } from 'queries';
import { FetchOrderCanAssignQuery, FetchOrderCanAssignQueryVariables } from 'types/graphql';

export const getConfirmAvailabilityQueryConfig = ({
  orderId,
  onSuccess,
  onError,
}: {
  orderId: number;
  onSuccess: (data: FetchOrderCanAssignQuery) => void;
  onError: () => void;
}): UseGQLQueryConfig<
  FetchOrderCanAssignQuery,
  FetchOrderCanAssignQuery,
  FetchOrderCanAssignQueryVariables
> => ({
  key: 'CONFIRM_AVAILABILITY_CAN_ASSIGN_VALIDATION_QUERY',
  query: QUERY_fetchOrderCanAssign,
  onSuccess,
  onError,
  variables: {
    orderId,
  },
});
